'use strict';
var base = require('base/checkout/summary');

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
base.updateTotals = function (totals) {
    var freeShipping = 'FREE';
    $('.shipping-total-cost').text(totals.totalShippingCost);
    $('.tax-total').text(totals.totalTax);
    $('.sub-total').text(totals.subTotal);
    $('.grand-total-sum').text(totals.grandTotal);
    var KlarnaMax = $('.js-grand-total').data('klarnamaxorderamount');
    var KlarnaMin = $('.js-grand-total').data('klarnaminorderamount');
    var klarnadisable = true;
    if (parseFloat(totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax)) {
        klarnadisable = false;
        $('.klarna-express-checkout-container.klarnamaindiv').removeClass('d-none');
    } else {
        $('.klarna-express-checkout-container.klarnamaindiv').addClass('d-none');
    }

    if ($('.page').hasClass('checkout') && $('.express-checkout-continue').length && $('.express-checkout-continue').data('klarnaonlyenabled') === true) {
        if (parseFloat(totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax)) {
            $('.express-checkout-continue').removeClass('klarnaonly-hide');
            $('.express-checkout-continue').addClass('klarnaonly-enabled');
        } else if (!(parseFloat(totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax))) {
            $('.express-checkout-continue').removeClass('klarnaonly-enabled');
            $('.express-checkout-continue').addClass('klarnaonly-hide');
        }
    }

    if ($('.page').hasClass('checkout') && $('.express-checkout-continue').length && $('.express-checkout-continue').data('applepayklarnaonlyenabled') === true) {
        if (parseFloat(totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax)) {
            $('.express-checkout-continue').removeClass('applepayklarnaonly-hide');
            $('.express-checkout-continue').addClass('applepayklarnaonly-enabled');
        } else if (!(parseFloat(totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax))) {
            $('.express-checkout-continue').removeClass('applepayklarnaonly-enabled');
            $('.express-checkout-continue').addClass('applepayklarnaonly-hide');
        }
    }

    $('.js-grand-total').data('isklarnadisable', klarnadisable);
    var afterpayMax = $('.js-grand-total').data('afterpaymaxorderamount');
    var afterpayMin = $('.js-grand-total').data('afterpayminorderamount');
    var preOrderItems = $('.js-grand-total').data('haspreorderitems');
    var afterpayDisable = true;
    if (parseFloat(totals.grandTotal.replace(/[^0-9.]/g, '')) >= parseFloat(afterpayMin) && parseFloat(totals.grandTotal.replace(/[^0-9.]/g, '')) <= parseFloat(afterpayMax) && !preOrderItems) {
        afterpayDisable = false;
    }
    $('.js-grand-total').data('isafterpaydisable', afterpayDisable);
    // discounted Shipping Cost
    if (totals.shippingAmountTotal.value) {
        $('.shipping-total-cost').text(totals.shippingAmountTotal.formatted).removeClass('shipping-cost-free');
    } else {
        $('.shipping-total-cost').text(totals.totalShippingCost);
    }

    if (totals.shippingAmountTotal.value === 0) {
        $('.shipping-total-cost').empty().append(freeShipping).addClass('shipping-cost-free');
    } else {
        $('.shipping-total-cost').empty().append(totals.shippingAmountTotal.formatted);
    }

    if (totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('d-none');
        $('.shipping-discount-total').text('- ' +
            totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('d-none');
    }

    if (totals.giftCardTotals.giftCardTotalAmount.value > 0) {
        $('.gift-card-total-amt').text('-' + totals.giftCardTotals.giftCardTotalAmount.formatted);
        $('.gift-card-item').removeClass('d-none');
    } else {
        $('.gift-card-item').addClass('d-none');
    }

    if ($('#checkout-main').length && ($('#checkout-main').attr('data-checkout-stage') === 'payment' || $('#checkout-main').attr('data-checkout-stage') === 'shipping')) {
        if (totals.giftCardTotals && $('.applied-card-container').length) {
            $('.applied-card-container').html('');

            totals.giftCardTotals.appliedGiftCard.forEach(function (item, index) {
                let $appliedCard = $('.applied-card-placeholder').clone();
                $appliedCard.find('.applied-card__amount').text(item);
                $appliedCard.find('a.remove').data('cardnumber', totals.giftCardTotals.giftCardno[index]);
                $appliedCard.removeClass('applied-card-placeholder d-none');
                $appliedCard.addClass('applied-card');
                $('.applied-card-container').append($appliedCard);
            });
        }
    }
};

module.exports = base;
